module.exports = __webpack_public_path__ + "1bff5bf382ae180d224aa37e71dcdfc5.svg";